module.exports = {
      id: "cricket-usage",
      viewBox: "0 0 21.217 19.952",
      url: "/" + "sprite-84df178c245af8be09420a4d0455d997.svg#cricket",
      toString: function () {
        return this.url;
      }
    }